<template>
  <ancestryline-modal title="dataTable.quick-protocol-create.title" id="modal-quick-protocol-create-filters" :close="true" @close="close" :loading="false">
    <form @submit.prevent="applyFilter">
      <card :header="$t('dataTable.quick-protocol-create.title')" class="p-col-12" >
        <coff-input-text v-model="filters.name" label="dataTable.quick-protocol-create.columns.name" class="p-col-12 p-md-6 p-lg-6" />
        <coff-input-radio v-model="filters.isActive" @update="forceUpdateField('isActive', $event)" :options="options" label="dataTable.quick-protocol-create.columns.active" class="p-col-12 p-md-6 p-lg-6" />
      </card>

    </form>

    <template #footer>
      <div class="p-col-12">
        <Button :label="$t('btn.clear')" @click.prevent="clearFilter" class="p-button-secondary p-mr-auto"/>
        <Button :label="$t('btn.filter')" @click.prevent="applyFilter" class="float-right p-button-primary"/>
      </div>
    </template>

  </ancestryline-modal>
</template>

<script>
import DialogService from "@/business/ModalBusiness";

export default {
  name: "ModalQuickProtocolFilter",

  props: {
    filters: {},
  },

  data() {
    return {
      options: [
        {value: true, label: 'field.default.yes'},
        {value: false, label: 'field.default.no'}
      ],
    }
  },

  methods:{

    forceUpdateField(field, value){
      this.$set(this.filters, field, value);
    },

    close(){
      DialogService.closeModal();
    },

    clearFilter(){
      this.filters = {name: null, isActive: null};
    },

    applyFilter(){
      DialogService.closeModal(this.filters);
    },

  },

}
</script>

<style scoped>

</style>